import { useQuery } from 'data-fetching-client';
import { GET_PRODUCTS_QUERY } from '../../../../__generated__/chirp/com/hubspot/buying/rpc/ProductRpc.dfc.new';
import { GET_PRODUCTS_QUERY as GET_PRODUCTS_QUERY_NO_AUTH } from '../../../../__generated__/chirp/com/hubspot/buying/rpc/PublicProductRpc.dfc.new';
import { useIsInAppAuth } from '../user/useUserInfo';
const useProductDetailsQuery = (isAppAuth = false) => isAppAuth ? GET_PRODUCTS_QUERY : GET_PRODUCTS_QUERY_NO_AUTH;
export const useProductDetails = ({
  productApiName
}) => {
  var _productDetailsQuery$;
  const isAppAuth = useIsInAppAuth();
  const query = useProductDetailsQuery(isAppAuth);
  const productDetailsQuery = useQuery(query, {
    variables: {
      productApiNames: productApiName ? [productApiName] : []
    },
    skip: !productApiName
  });
  if (!productApiName) return {
    productDetails: undefined,
    loading: false
  };
  const productDetails = (_productDetailsQuery$ = productDetailsQuery.data) === null || _productDetailsQuery$ === void 0 ? void 0 : _productDetailsQuery$.result.productsByName[productApiName];
  const {
    loading,
    error
  } = productDetailsQuery;
  return {
    productDetails,
    loading,
    error
  };
};
export const useIsCoreSeatSku = ({
  productApiName
}) => {
  const {
    productDetails
  } = useProductDetails({
    productApiName
  });
  return (productDetails === null || productDetails === void 0 ? void 0 : productDetails.skuCategoryName) === 'CORE_PLATFORM_SEATS';
};
export const useProductDetailsForArray = ({
  productApiNames
}) => {
  const isAppAuth = useIsInAppAuth();
  const query = useProductDetailsQuery(isAppAuth);
  const {
    data,
    loading,
    error
  } = useQuery(query, {
    variables: {
      productApiNames
    }
  });
  const productDetails = data === null || data === void 0 ? void 0 : data.result;
  return {
    productDetails,
    loading,
    error
  };
};
export const useHasProductInProductDetails = ({
  productApiName
}) => {
  const {
    productDetails,
    loading,
    error
  } = useProductDetails({
    productApiName
  });
  return {
    hasProduct: !!productDetails,
    loading,
    error
  };
};
export const useHasAnyCoreSeatsInProductDetails = () => {
  var _productDetails$produ;
  const {
    productDetails,
    loading
  } = useProductDetailsForArray({
    productApiNames: ['core-seats-starter', 'core-seats-professional', 'core-seats-enterprise']
  });
  const hasAnyCoreSeats = Object.keys((_productDetails$produ = productDetails === null || productDetails === void 0 ? void 0 : productDetails.productsByName) !== null && _productDetails$produ !== void 0 ? _productDetails$produ : {}).length > 0;
  return {
    hasAnyCoreSeats,
    loading
  };
};
export const useHasAnySuiteBundlesInProductDetails = () => {
  var _productDetails$produ2;
  const {
    productDetails,
    loading
  } = useProductDetailsForArray({
    productApiNames: ['crm-suite-starter-bundle', 'crm-suite-professional-bundle', 'crm-suite-enterprise-bundle']
  });
  const hasAnySuiteBundles = Object.keys((_productDetails$produ2 = productDetails === null || productDetails === void 0 ? void 0 : productDetails.productsByName) !== null && _productDetails$produ2 !== void 0 ? _productDetails$produ2 : {}).length > 0;
  return {
    hasAnySuiteBundles,
    loading
  };
};